export default {
    chamadosManutencao: [],
    chamadoManutencao: {},
    ultimaAtualizacaoListaChamadoManutencao: Date
}